import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled, { ThemeProvider, css } from 'styled-components';
import ClickOutside from 'react-onclickout';
import routes, { routeFor } from 'helpers/routes';
import { ProductCategoryType } from 'types';
import { closeNavDrawer } from 'ducks/ui';
import { colors, sp } from 'styles/theme';
import { NavItem, SubNav, Section, SubItem } from './components';

// prettier-ignore
const StyledMainNav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;

  ${props => props.theme.vertical && css`
    display: block;
  `}
`;

const ExternalLink = styled.div`
  display: flex;
  a {
    display: block;
    color: ${colors.blue} !important;
    margin-bottom: ${sp.s};
    font-size: 14px;
    font-weight: 600;
    text-decoration: none !important;
  }
`;

const propTypes = {
  closeDrawer: PropTypes.func.isRequired,
};

class MainNav extends React.Component {
  static propTypes = {
    vertical: PropTypes.bool,
    productCategories: PropTypes.arrayOf(ProductCategoryType).isRequired,
  };

  static defaultProps = {
    vertical: false,
  };

  state = { openItem: undefined };

  onClickItem = item => {
    this.props.closeDrawer();
    if (this.state.openItem === item) {
      this.setState({ openItem: undefined });
    } else {
      this.setState({ openItem: item });
    }
  };

  onClickOut = () => this.setState({ openItem: undefined });

  render() {
    const { openItem } = this.state;
    const { vertical, productCategories } = this.props;

    return (
      <ClickOutside onClickOut={this.onClickOut}>
        <ThemeProvider theme={{ vertical }}>
          <StyledMainNav>
            <NavItem
              onClick={() => this.onClickItem('shop')}
              isOpen={openItem === 'shop'}
              title="Shop Services"
            >
              <SubNav isOpen={openItem === 'shop'}>
                <Section title="Services">
                  <SubItem to="/services" onClick={() => this.onClickItem()}>
                    All
                  </SubItem>
                  {productCategories.map(pc => (
                    <SubItem
                      key={pc.id}
                      to={routeFor(routes.products.category, pc.slug)}
                      onClick={() => this.onClickItem()}
                    >
                      {pc.name}
                    </SubItem>
                  ))}
                </Section>
              </SubNav>
            </NavItem>

            <NavItem
              onClick={() => this.onClickItem('about')}
              isOpen={openItem === 'about'}
              title="About"
            >
              <SubNav isOpen={openItem === 'about'}>
                <Section title="About Us">
                  <SubItem to="/who-we-are" onClick={() => this.onClickItem()}>
                    Who We Are
                  </SubItem>
                  <SubItem
                    to="/how-it-works"
                    onClick={() => this.onClickItem()}
                  >
                    How It Works
                  </SubItem>
                </Section>
              </SubNav>
            </NavItem>

            <NavItem
              onClick={() => this.onClickItem('work')}
              isOpen={openItem === 'work'}
              title="Our Work"
            >
              <SubNav isOpen={openItem === 'work'}>
                <Section title="Our Work">
                  <SubItem to="/work" onClick={() => this.onClickItem()}>
                    Case Studies
                  </SubItem>
                  <ExternalLink>
                    <a
                      className="ExternalSubItem"
                      href="https://markettap.pb.gallery/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Portfolio
                    </a>
                  </ExternalLink>
                </Section>
              </SubNav>
            </NavItem>
            <NavItem
              to="/tapd-in"
              title="Tap'd In"
              onClick={() => this.onClickItem()}
            />
            <NavItem
              to="/contact-us"
              title="Contact"
              onClick={() => this.onClickItem()}
            />
          </StyledMainNav>
        </ThemeProvider>
      </ClickOutside>
    );
  }
}

MainNav.propTypes = propTypes;

const mapStateToProps = state => ({ isOpen: state.ui.isNavDrawerOpen });
const mapDispatchToProps = { closeDrawer: closeNavDrawer };
export default connect(mapStateToProps, mapDispatchToProps)(MainNav);



// WEBPACK FOOTER //
// ./src/components/shared/MainNav/MainNav.jsx